import React from 'react'
import Radium from 'radium'
import colors from '../theme/colors'

export default Radium(({ noTopLine, noBottomLine, multiline, children }) => (
  <div style={[
    styles.container,
    multiline && styles.multiline.container,
    noTopLine && styles.noTopLine.container,
  ]}>
    {children}
  </div>
))

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '20px 0',
    borderTop: `1px solid ${colors.lightLightGrey}`,
    wordBreak: 'break-word',
  },
  noTopLine: {
    container: {
      borderTop: 0,
      padding: '10px 0 20px',
    },
  },
  multiline: {
    container: {
      flexDirection: 'column',
    },
  },
}
